import React from 'react';
import {AgGridReact} from 'ag-grid-react';
import styled from 'styled-components';
import DecimalRenderer from '../../componentes/componentes_generales/grid/col_render_numerodecimal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actualizarChequesSeleccionadosEnDistribucion } from '../../actions/bancos/act_banc05';

const ContenedorGridDetCheques = styled.div`
  position: relative;
  background: #fafafa;
  height: 100%;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border-left: 2px solid grey;
  border-bottom: 2px solid lightgray;
  border-right: 2px solid lightgray;
`;

class GridDetCheques extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      columnsDefDetGridCheques:[
        { headerName: "",
          width: 30,
          checkboxSelection: true,
          headerCheckboxSelection: true,  
          headerCheckboxSelectionFilteredOnly: true,        
          suppressSorting: true,          
          suppressFilter: true,
          pinned: true
        },   
        { headerName: "No.",
          field: "Nro",
          width: 40,                 
          suppressFilter: true
        },
        {
          headerName: "F. Vcto. Cheque",
          field: "FechaVctoCheque",
          width: 80
        },
        { headerName: "Cliente",
          field: "Cliente",
          width: 200
        },     
        { headerName: "Banco",
          field: "Banco",
          width: 140          
        },
        { headerName: "Cuenta",
          field: "Cuenta",
          width: 90          
        },
        { headerName: "Cheque",
          field: "Cheque",
          width: 65       
        },              
        {
          headerName: "Valor",
          field: "Valor",
          width: 70,
          cellRendererFramework: DecimalRenderer
        }
      ],
      parentRecord: this.props.node.parent.data
    };  
    this.onGridDetChequesReady=this.onGridDetChequesReady.bind(this);
    this.onSelectionChanged=this.onSelectionChanged.bind(this);
    this.props.reactContainer.style.height = '100%';
  }
  
  onGridDetChequesReady(params) {
    this.apiGridDetCheques = params.api;
    this.columnApiGridDetCheques = params.columnApi;
    this.apiGridDetCheques.setRowData(this.state.parentRecord.Cheques);
    setTimeout(() => {
        this.apiGridDetCheques.sizeColumnsToFit();
    })
  }

  onSelectionChanged() {
    // Cada vez que cambia la selección, esta es guardada.
    let codCtaDepositar = this.state.parentRecord.CodCuentaDepositar;
    let chequesSeleccionados = this.apiGridDetCheques.getSelectedRows();
    
    
    let existeCtaDepositar = false;
    let chequesDistribSeleccionados = [...this.props.chequesDistribSeleccionados];

    this.props.chequesDistribSeleccionados.forEach((item, i) => {
      if (item.CodCuentaDepositar===codCtaDepositar){
        existeCtaDepositar = true;
        chequesDistribSeleccionados[i].Cheques = chequesSeleccionados
      }
    });

    if (!existeCtaDepositar){
      chequesDistribSeleccionados.push({CodCuentaDepositar: codCtaDepositar, Cheques: chequesSeleccionados});
    }
    // Asignacion de nueva selección de cheques.
    this.props.actualizarChequesSeleccionadosEnDistribucion(chequesDistribSeleccionados);
  }

  render(){
    return(      
      <ContenedorGridDetCheques>
        <AgGridReact
          suppressMovableColumns={true}
          onGridReady={this.onGridDetChequesReady}
          columnDefs={this.state.columnsDefDetGridCheques}          
          enableSorting
          enableColResize
          enableFilter
          rowSelection='multiple'
          onSelectionChanged={this.onSelectionChanged}
        >
        </AgGridReact>
      </ContenedorGridDetCheques>
    )      
  }  
}

const mapStateToProps = state => {
  return {
    chequesDistribSeleccionados: state.bancos.chequesDistribSeleccionados
  }
}

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ actualizarChequesSeleccionadosEnDistribucion }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GridDetCheques);